import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPT_PUBLICATIONS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={DEPT_PUBLICATIONS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/publications/$id")({
  component: Edit,
});
